console.log("Pango coupon loading...");

//var exchange_url = "https://pango-bundles-coupon.cap.pangostudio.com/exchange?code=";
var exchange_url = "https://pango-bundles-coupon.stgcap.pangostudio.com/exchange?code=";

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

//Aux function to erase the coupon cookie
function deletecouponcookie()
{
  var name="pango-coupon";
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  let  couponForm= document.getElementById("pango-coupon-form");
  let  acceptedMessage= document.getElementById("pango-ok");
  couponForm.style.display='block';
  acceptedMessage.style.display='none';
}

window.onload = (event) => {
  console.log("page is fully loaded");
  let couponCookie = getCookie("pango-coupon");
  //console.log('GALLETA: ',couponCookie);
  if(couponCookie!=null)
  {
    let couponForm= document.getElementById("pango-coupon-form");
    let acceptedMessage= document.getElementById("pango-ok");
    couponForm.style.display='none';
    acceptedMessage.style.display='block';
  }
};


async function pangoclick(){
      var code=document.getElementById("pango-coupon").value;
      //var test="hola";
      //console.log(code);
      var bodyc="code="+code;

      var payload = {
          code: code,
      };

      var data = new FormData();
      data.append( "json", JSON.stringify( payload ) );
      console.log(bodyc);
      
      /*fetch('https://919e-2a01-c50f-fe40-1000-bd27-38ad-1134-9900.ngrok-free.app/exchange?code='+code,{method: 'GET',headers: {
      },mode: 'no-cors'})
        .then(response => response.json)
        .then(json => console.log(JSON.stringify(json)))
        .catch(function(error) {
            console.log('Hubo un problema con la petición Fetch:' + error.message);
          });
      */
      jQuery.getJSON('https://api.db-ip.com/v2/free/self', function(geoInfo) {
        pangocheckcoupon(geoInfo,code);
      }).fail(
        function () {
          pangocheckcoupon(null,code);
        }
      );
  }

async function pangocheckcoupon(geoInfo,code){
  if(geoInfo === null){
    ip_user = '';
  }
  else{
    ip_user = geoInfo['ipAddress'];
  }
  await fetch(exchange_url+code+'&ip_user='+ip_user,{method: 'GET',headers: {
      }}).then(function(response) {
      if(response) {
        return response.json();
      } else {
        return 0;
      }
    }).then(function(data){
        console.log('DATA: ',data);
        if(data.ok==true)
        {
          console.log("CUPON VALIDO");
          document.cookie = "pango-coupon="+code;
          //document.cookie = "discount_code="+code;
          let couponForm= document.getElementById("pango-coupon-form");
          let acceptedMessage= document.getElementById("pango-ok");
          couponForm.style.display='none';
          acceptedMessage.style.display='block';
        }
        else if(data.ok==false)
        {
          console.log("CUPON INVALIDO");
          //document.cookie = "pango-coupon=; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
          var expirationDate = new Date();
          expirationDate.setTime(expirationDate.getTime() + (30 * 60 * 1000)); // 30 minutos en milisegundos
          document.cookie = name + '=; Path=/; Expires=' + expirationDate.toUTCString() + ';';
        }
        else
        {
          console.log("INDEFINIDO");  
        }
    })
    .catch(function(error) {
      console.log('Hubo un problema con la petición Fetch:' + error.message);
    });
}
    